import { get } from "lodash";

export const shouldUseHomePage = (userPerson) => {
  return typeof get(userPerson, "aggregateId") !== "undefined";
};

export const isSuggestChangeEnabled = (workspace) => {
  return get(workspace, "config.featureFlags.enableSuggestTeamChange", false);
};
